import React, { useState } from 'react';
import styles from './index.module.scss';

type Props = {
  options: { key: string; value: string }[];
  selected: string;
  onSelect: (key: string) => void;
};

const Select = (props: Props) => {
  const selected = props.options.find((option) => option.key === props.selected)

  if (!selected) return null
  return (
    <>
      <label htmlFor="selector" className={styles.label}>{selected.value}</label>
      <select onChange={(e) => props.onSelect(e.target.value)} name="" id="selector" className={styles.select}>
        {props.options.map((option) => {
          return (
            <option value={option.key} selected={props.selected === option.key}>
              {option.value}
            </option>
          );
        })}
      </select>
      </>
  );
};

export default Select;
